import React, { useEffect, useRef, useState } from "react";
import FeaturedProducts from "../Components/Layout/FeaturedProducts";
import Products from "../Components/Layout/Product/Products";
import Modal from "../Components/Layout/Modal";
import { useAddProductContext } from "../Contexts/AddProductContext";
import AddProduct from "../Components/Layout/Product/AddProduct";
import DefaultLayout from "../Layouts/DefaultLayout";
import { useCartContext } from "../Contexts/CartContext";
import { useLoginContext } from "../Contexts/LoginContext";
import LoginSuccessful from "../Components/Layout/LoginSuccessful";
import StoreService from "../Services/StoreService";
import { useOrderTypeContext } from "../Contexts/OrderTypeContext";
import { useStoreContext } from "../Contexts/StoreContext";
import { useLayoutContext } from "../Contexts/LayoutContext";
import { isArraysEqual } from "../Utils/Helpers";
import WelcomeStoreCounter from "../Components/Layout/WelcomeStoreCounter";
import { dataFakeForLoading, PRODUCT_TYPE_COMPOSITE } from "../Utils/Constants/Product";
import { useStoreHook } from "../Hooks/StoreHook";
import { ORDER_TYPE_STORE_COUNTER } from "../Utils/Constants/Service";

const Home = () => {

    const { showAddProduct, setShowAddProduct, product, category} = useAddProductContext();
    const { setCartTemp, showCartIsFinished, cartDisplay } = useCartContext();
    const { showLoginSuccessful, setShowLoginSuccessful, token, guestToken } = useLoginContext();
    const { orderType, getOrderTypeIdByName, isStoreCounter } = useOrderTypeContext();
    const { currentStore, tables } = useStoreContext();
    const { company, setProductsToSearch, welcomeScreenRead, categories, setCategories, setWelcomeScreenRead, isMobile } = useLayoutContext();
    const [ loadingCategories, setLoadingCategories ] = useState<boolean>(true);
    const { getCashier, createGuestToken, createGuestCart, storeIsOpen, loadTables } = useStoreHook();
    const [ categoriesWhithoutFeaturedProducts, setCategoriesWhithoutFeaturedProducts ] = useState<any>([]);
    const [ allCategories, setAllCategories ] = useState<any>([]);

    const previousTokenRef = useRef(token);

    const loadProducts = async () => {
        setLoadingCategories(true);
        try {
            const storeSevice = new StoreService(orderType);
            const payload = {
                store_id: currentStore.id,
                order_type: Number(getOrderTypeIdByName(orderType))
            }
            const products = await storeSevice.products(payload);
            if (products) {
                setAllCategories(products);

                if (isMobile) {
                    setCategories(products)
                } else {
                    const categoriesWithoutFeaturedProducts = products.filter((cat: any) => cat.id != null);
                    if (categoriesWithoutFeaturedProducts) {
                        setCategoriesWhithoutFeaturedProducts(categoriesWithoutFeaturedProducts);
                        setCategories(categoriesWithoutFeaturedProducts);
                    }
                }
            } else {
                setCategories([]);
                setAllCategories([]);
            }
        } catch (error) {
        } finally {
            setLoadingCategories(false);
        }
    }

    useEffect(() => {
        document.title = currentStore.name || company.name;
        storeIsOpen();
        loadProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleShowFeaturedProducts = () => {
        if (allCategories?.length > 0 && !isArraysEqual(allCategories, dataFakeForLoading)) {
            if (isMobile) {
                setCategories(allCategories)
            } else {
                setCategories(categoriesWhithoutFeaturedProducts);
            }
        }
    }

    useEffect(() => {
        handleShowFeaturedProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMobile]);


    useEffect(() => {
        if (orderType !== ORDER_TYPE_STORE_COUNTER) {
            if (guestToken) {
                createGuestCart()
            } else {
                createGuestToken();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guestToken]);

    useEffect(() => {
        if (isStoreCounter && currentStore && token && previousTokenRef.current !== token) {
            loadTables();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    useEffect(() => {
        if (orderType === ORDER_TYPE_STORE_COUNTER) {
            if (currentStore && !cartDisplay) {
                getCashier();
            }
            if (product && (!tables || tables.length === 0) && token) {
                loadTables();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cartDisplay, product, orderType]);

    useEffect(() => {
        if (allCategories?.length > 0 && !isArraysEqual(allCategories, dataFakeForLoading)) {
            const allProducts: any[] = [];
            allCategories.forEach((category: any) => {
                category.products.forEach((product: any) => {
                    if (!allProducts.some((prod) => prod.id === product.id)) {
                        allProducts.push(product);
                    }
                });
            });
            setProductsToSearch(allProducts);

            const categoriesWithoutFeaturedProducts = allCategories.filter((cat: any) => cat.id != null);
            if (categoriesWithoutFeaturedProducts) {
                setCategoriesWhithoutFeaturedProducts(categoriesWithoutFeaturedProducts);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allCategories]);

    return (
        <>
            <DefaultLayout categories={categories}>
                {/* <Banners /> */}
                {currentStore && <FeaturedProducts />}
                {(currentStore && categories?.length > 0)
                    ? <Products categories={categories} loading={loadingCategories} />
                    : <div className="w-full h-full flex items-center justify-center text-sm text-gray-500">Nenhum produto encontrado</div>
                }
            </DefaultLayout>

            {/* MODAL ADD PRODUCT */}
            {product && !showCartIsFinished && (
                <Modal open={showAddProduct} className={`w-full rounded-none md:rounded-lg m-0 h-dvh md:h-auto ${product.type === PRODUCT_TYPE_COMPOSITE ? 'md:max-w-3xl lg:max-w-4xl' : 'md:max-w-lg'}`}
                    onClose={() => {
                        setShowAddProduct(false);
                        setCartTemp([]);
                    }}>
                    <AddProduct product={product} category={category} />
                </Modal>
            )}

            <Modal open={showLoginSuccessful} closeable={false} className="max-w-sm m-4" onClose={() => setShowLoginSuccessful(false)}>
                <LoginSuccessful />
            </Modal>

            {isStoreCounter &&
                <Modal open={Boolean(!welcomeScreenRead && company && currentStore)} closeable={false} className="flex items-center justify-center min-h-dvh w-full rounded-none" onClose={() => setWelcomeScreenRead(true)}>
                    <WelcomeStoreCounter />
                </Modal>
            }
        </>
    );
};

export default Home;